"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setJitaDisabled = exports.SetJitaDisabled = exports.SetJitaDisabledActionTypes = exports.setJitaEnabled = exports.SetJitaEnabled = exports.SetJitaEnabledActionTypes = exports.loadJitaSettings = exports.FetchJitaEnabled = exports.FetchJitaEnabledActionTypes = exports.JitaActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _I18n = _interopRequireDefault(require("I18n"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var JitaActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_JITA_ENABLED: null,
  SET_JITA_ENABLED: null,
  SET_JITA_DISABLED: null
}, 'jita');
exports.JitaActionTypes = JitaActionTypes;
var FetchJitaEnabledActionTypes = (0, _actions.createRequestTypes)(JitaActionTypes.FETCH_JITA_ENABLED);
exports.FetchJitaEnabledActionTypes = FetchJitaEnabledActionTypes;
var FetchJitaEnabled = (0, _actions.createRequestActions)(FetchJitaEnabledActionTypes, {
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(FetchJitaEnabledActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.jita.notifications.fetchError')));
  }
});
exports.FetchJitaEnabled = FetchJitaEnabled;
var loadJitaSettings = (0, _fluxActions.createAction)(JitaActionTypes.FETCH_JITA_ENABLED);
exports.loadJitaSettings = loadJitaSettings;
var SetJitaEnabledActionTypes = (0, _actions.createRequestTypes)(JitaActionTypes.SET_JITA_ENABLED);
exports.SetJitaEnabledActionTypes = SetJitaEnabledActionTypes;
var SetJitaEnabled = (0, _actions.createRequestActions)(SetJitaEnabledActionTypes, {
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SetJitaEnabledActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.jita.notifications.fetchError')));
  }
});
exports.SetJitaEnabled = SetJitaEnabled;
var setJitaEnabled = (0, _fluxActions.createAction)(JitaActionTypes.SET_JITA_ENABLED);
exports.setJitaEnabled = setJitaEnabled;
var SetJitaDisabledActionTypes = (0, _actions.createRequestTypes)(JitaActionTypes.SET_JITA_DISABLED);
exports.SetJitaDisabledActionTypes = SetJitaDisabledActionTypes;
var SetJitaDisabled = (0, _actions.createRequestActions)(SetJitaDisabledActionTypes, {
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SetJitaDisabledActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.security.jita.notifications.fetchError')));
  }
});
exports.SetJitaDisabled = SetJitaDisabled;
var setJitaDisabled = (0, _fluxActions.createAction)(JitaActionTypes.SET_JITA_DISABLED);
exports.setJitaDisabled = setJitaDisabled;